import { createFileRoute } from '@tanstack/react-router';
import { RelatorioHistoricoAlteracoesPreco } from '@/features/relatorio/page/cadastro/hitorico-alteracoes-preco/RelatorioHistoricoAlteracoesPreco';

export const Route = createFileRoute('/a/relatorio/cadastro/historico-alteracoes-preco')({
    component: RelatorioHistoricoAlteracoesPreco,
});
